var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoUpdateArrows = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico_update",
    d: "M20879.379,16534.914c.607-.361,3.143-1.463,3.143-6.25a.388.388,0,0,1,.059-.172h-2.316l3.865-4.775,3.871,4.775h-2.26c0,.057,0,.115,0,.172a6.026,6.026,0,0,1-6.344,6.334C20879.275,16535,20879.27,16534.977,20879.379,16534.914Zm-7.379-9.41h2.262a1.554,1.554,0,0,1-.006-.168,6.029,6.029,0,0,1,6.346-6.338c.119,0,.125.027.021.084-.607.367-3.143,1.469-3.143,6.254a.339.339,0,0,1-.061.168h2.318l-3.871,4.775Z",
    transform: "translate(-20872 -16518.998)",
    fill: "#999"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoUpdateArrows);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_update_arrows.b21eafc4b014e230494e1dba268f75a2.svg";